module.exports = __webpack_public_path__ + "static/media/2-FLYNT.3e8403cd.mp3";